import React from 'react';

export const LrOverlay = () => <div className="Overlay" />;
